import { Alpine, Livewire } from '@shared/livewire.js'
import { buildOnApprove, navigateAfterApproval } from '@shared/forms/paypal-approval.js'

Alpine.data('loadPaypalButton', (props) => ({
    props: props,
    error: null,
    // Terminal post-approval states. Either one hides the PayPal button so a donor whose redirect
    // stalls has nothing to click a second time.
    completed: false,
    unconfirmed: false,
    completedUrl: null,
    init() {
        const appEnv = this.props.appEnv
        const paypalClientId = this.props.paypalClientId
        const pmGateway = this.props.pmGateway
        const frequency = this.props.frequency
        const currency = this.props.currency
        const intentionId = this.props.intentionId
        const redirect = this.props.redirect
        const componentId = document
            .querySelector('[wire\\:id]')
            .getAttribute('wire:id')
        const errorCopy =
            pmGateway === 'paypal_donor'
                ? 'An error occurred while processing your donation payment. Please try again or contact customer service.'
                : 'An error occurred while processing your card. Please try again or contact us at help@wordonfire.institute'

        const setError = (error) => {
            this.error = error
        }

        const createOrder =
            frequency === 'one_time'
                ? async (data, actions) => {
                      try {
                          return await Livewire.find(componentId).call(
                              'createPaypalOrder'
                          )
                      } catch (error) {
                          console.log(error)
                          setError(errorCopy)
                      }
                  }
                : undefined

        const createSubscription =
            pmGateway === 'paypal_donor' && frequency !== 'one_time'
                ? async (data, actions) => {
                      try {
                          return await Livewire.find(componentId).call(
                              'createPaypalSubscription'
                          )
                      } catch (error) {
                          console.log(error)
                          setError(errorCopy)
                      }
                  }
                : pmGateway === 'paypal_wofi' || frequency !== 'one_time'
                ? async (data, actions) => {
                      try {
                          return await Livewire.find(componentId).call(
                              'createPaypalSubscription'
                          )
                      } catch (error) {
                          console.log(error)
                          setError(errorCopy)
                      }
                  }
                : undefined

        // Past this point PayPal has approved, so nothing here may show errorCopy ("Please try
        // again"): see paypal-approval.js for why a retry after approval double-charges.
        const onApprove = buildOnApprove({
            frequency,
            pmGateway,
            redirect,
            intentionId,
            capture: () => Livewire.find(componentId).call('capturePaypalOrder'),
            complete: (url) => {
                this.error = null
                this.completedUrl = url
                this.completed = true
                navigateAfterApproval(url, window.top)
            },
            unconfirmed: () => {
                this.error = null
                this.unconfirmed = true
            },
        })

        let paypalScript = document.createElement('script')
        paypalScript.type = 'text/javascript'
        paypalScript.src = `https://${
            appEnv === 'production' ? 'www' : 'sandbox'
        }.paypal.com/sdk/js?client-id=${paypalClientId}&components=buttons&currency=${currency}`
        if (pmGateway === 'paypal_wofi' || frequency !== 'one_time') {
            paypalScript.src += '&vault=true&intent=subscription'
        }
        paypalScript.onload = () => {
            paypal
                .Buttons({
                    style: {
                        layout: 'vertical',
                        color: 'black',
                        shape: 'rect',
                        label: 'paypal',
                    },
                    fundingSource: paypal.FUNDING.PAYPAL,
                    createOrder,
                    createSubscription,
                    onApprove,
                })
                .render('#paypal-button-container')
        }
        document.body.appendChild(paypalScript)
    },
}))
